import { useCallback } from 'react';
import { useIframeMessageContext } from '../../IframeMessageContext';
import { registerIframeMessageHook } from './IframeRegistration';
const MESSAGE_TYPE = 'send-editing';
export function useSendEditing() {
    const { postMessage } = useIframeMessageContext();
    const sendEditing = useCallback((isEdit) => {
        postMessage(MESSAGE_TYPE, isEdit);
    }, [postMessage]);
    return { sendEditing };
}
const handleMessage = (context, message) => {
    const { toggleEdit } = context;
    toggleEdit(Boolean(message.body), { shouldSendIframe: false });
};
registerIframeMessageHook(MESSAGE_TYPE, useSendEditing, handleMessage);
//# sourceMappingURL=useSendEditing.js.map